import { useSyncChannels } from "features/Integrations/hooks";
import { TertiaryButton } from "components/Button";

export default function SyncChannelsButton() {
  const {
    performRequest: syncChannels,
    state: { loading: isLoading },
  } = useSyncChannels();

  return (
    <TertiaryButton
      onClick={() => syncChannels()}
      isLoading={isLoading}
      loadingText="Syncing Channels"
      size="sm"
      height="100%"
      px={6}
      py={1}
    >
      Sync Channels
    </TertiaryButton>
  );
}
